export const country = window.ocm.config.country || "de";
export const isIntShop = country === "int";
export const countryIso = window.ocm.config.countryIso || "de";
export const language = window.ocm.config.language || "de";
export const carriers = window.ocm.config.carriers ?? {};
export const contextPath = window.ocm.config.encodedContextPath ?? `/${country}-de/shop`;
export const isClassicSite = window.ocm.isClassicSite ?? false;
export const shopContextPath = isClassicSite ? `/${country}-de/shop` : contextPath;
export const resourcesHostname = window.ocm.config.resourcesHostname;
export const commonResourcePath = window.ocm.config.commonResourcePath;

// Epoq
export const isEpoqRecosCartEnabled = window.ocm.config.isEpoqRecosCartEnabled ?? false;
export const epoqRecosPlpChunkSize = window.ocm.config.epoqRecosPlpChunkSize ?? 24;
export const isEpoqRecosPdpEnabled = window.ocm.config.isEpoqRecosPdpEnabled ?? false;

// Contact Center
export const captchaPublickey = window.ocm.captchaOptions?.publickeyContactcenter || "";
export const captchaActive = window.ocm.captchaOptions?.displayContactcenter;

export const department = window.ocm.config.department;

export const hasFreeShippingBenefits = window.ocm.config.hasFreeShippingBenefits ?? false;
export const freeShippingOrderLimit = window.ocm.config.freeShippingOrderLimit;

// My Account
export const memberGetsMemberClassicEnabled = window.ocm.config.memberGetsMemberClassicEnabled ?? false;
export const memberGetsMemberShopEnabled = window.ocm.config.memberGetsMemberShopEnabled ?? false;
export const isClubQuestEnabled = window.ocm.config.isClubQuestEnabled ?? false;
export const showClubRewards = window.ocm.config.showClubRewards ?? true;

// TUB-22966 Gutschein-Code-Position A/B-Test
export const isVoucherCodeBelowReco = window.ocm.config.isVoucherCodeBelowReco ?? true;
export const isVoucherCodeAboveReco = window.ocm.config.isVoucherCodeAboveReco ?? false;
export const isVoucherCodeOnTop = window.ocm.config.isVoucherCodeOnTop ?? false;

// TUB-21783 Recommendation below PLP A/B-Test
export const isRecommendationBelowPlpEnabled = window.ocm.config.isRecoBelowPLPEnabled ?? false;

// TUB-23336 Neu-Verteilerseite A/B-Test
export const isNeuOverviewPageEnabled = window.ocm.config.isNeuOverviewPageEnabled ?? false;

export const isMinifiedHeaderCartEnabled = window.ocm.config.isMinifiedHeaderCartEnabled ?? false;

// TUB-23613 Brand Following Widget A/B-Test
export const isBrandFollowingWidgetEnabled = window.ocm.config.isBrandFollowingWidgetEnabled ?? false;

// TUB-24972 Wishlist Reco A/B-Test
export const isWishlistRecoEnabled = window.ocm.config.isWishlistRecoEnabled ?? false;

// TUB-25889 Show 30-day best price only with Sale/IPM tag
export const alwaysShow30DayBestPrice = window.ocm.config.alwaysShow30DayBestPrice ?? true;
